import { render } from "./MealsTable.vue?vue&type=template&id=1d6076bf"
import script from "./MealsTable.vue?vue&type=script&lang=js"
export * from "./MealsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__